import ODataReaderNode from './types/odataReader';

export const odataNodes = {
  oDataReader: ODataReaderNode,
};
